//import axios from 'axios'
import axios from './axiosConfig'

export default {

    /**
     * Sends the data entered by the user to the create ConfigurationController.
     *
     */
    async createProject(payload) {
        console.log('payload')
        console.log(JSON.stringify(payload))
        return await axios({
            url: `/${window._locale}/` + 'create/project',
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },
    async updateProject(payload) {
        console.log('payload')
        console.log(JSON.stringify(payload))
        return await axios({
            url: `/${window._locale}/` +'update/project',
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },

    /**
     * Receives the project data from the return project controller
     *
     */
    async returnProjects() {
        return axios.post('/get/projects')
            .then(response => {
                return response.data;
            });
    },

    async returnFullProjectData(payload) {
        return axios.post(`/${window._locale}/` +'get/entire/data', payload)
            .then(response => {
                return response.data;
            });
    },

    async createConfiguration(payload) {
        console.log('payload')
        console.log(JSON.stringify(payload))
        return await axios({
            url: `/${window._locale}/` +'create/configuration',
            data: JSON.parse(JSON.stringify(payload)),
            method: 'POST'
        });
    },
}
